const initialState = {
  methodologyUrl: null,
  plantAddress: null,
  devices: [],
};

export const setVerifierMethodologyUrl = (methodologyUrl) => ({
  type: "VERIFIER_METHODOLOGY_URL_SET",
  payload: methodologyUrl,
});

export const clearVerifierMethodologyUrl = () => ({
  type: "VERIFIER_METHODOLOGY_URL_CLEAR",
});

export const verifierReducer = (state = initialState, action) => {
  switch (action.type) {
    case "VERIFIER_IOT_DATA_SET":
      return {
        ...state,
        plantAddress: action.payload.QuantificationMethodology,
        devices: action.payload.devices,
      };
    case "VERIFIER_IOT_DATA_CLEAR":
      return { ...initialState };
    case "VERIFIER_METHODOLOGY_URL_SET":
      return {
        ...state,
        methodologyUrl: action.payload,
      };
    case "VERIFIER_METHODOLOGY_URL_CLEAR":
      return {
        ...state,
        methodologyUrl: null,
      };
    default:
      return state;
  }
};
